var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgTiff = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 7C13 7 12 6 12 4V1H6C4 1 3 2 3 4V16C3 18 4 19 6 19H15C17 19 18 18 18 16V7H15Z",
    fill: "#4D6EF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H18L12 1V4C12 6 13 7 15 7Z",
    fill: "#4D6EF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.8859 11.4902V12.1752H6.9559V15.0002H6.1009V12.1752H5.1709V11.4902H7.8859Z",
    fill: "#4D6EF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17 11.4902V15.0002H8.315V11.4902H9.17Z",
    fill: "#4D6EF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0746 11.4902V12.1752H10.6446V12.9152H11.7146V13.5802H10.6446V15.0002H9.78961V11.4902H12.0746Z",
    fill: "#4D6EF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.809 11.4902V12.1752H13.379V12.9152H14.449V13.5802H13.379V15.0002H12.524V11.4902H14.809Z",
    fill: "#4D6EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTiff);
export default ForwardRef;